module.exports = __webpack_public_path__ + "assets/img/1_1694_big.179f34b7.jpg";